import { registerBlockType } from "@wordpress/blocks"
import Edit from "./edit"
import Save from "./save"

registerBlockType("puroclean/emergency-response", {
  edit: Edit,
  save: Save
}) 